import * as Types from '../../../../__generated__/schema';

import {
  ActorTeaserAPIToken,
  ActorTeaserUser,
} from '../../../graphql/fragments/ActorTeaser.generated';
import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import { ActorTeaser } from '../../../graphql/fragments/ActorTeaser.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateAIConversationVariables = Types.Exact<{
  input: Types.CreateAIConversationInput;
}>;

export type CreateAIConversation = {
  createAIConversation: Pick<Types.CreateAIConversationOutput, 'streamId'> & {
    conversation: Pick<
      Types.AIConversation,
      'id' | 'title' | 'private' | 'saved' | 'createdAt' | 'updatedAt'
    > & { createdBy?: Types.Maybe<ActorTeaserAPIToken | ActorTeaserUser> };
  };
};

export const CreateAIConversationDocument = gql`
  mutation CreateAIConversation($input: CreateAIConversationInput!) {
    createAIConversation(input: $input) {
      conversation {
        id
        title
        private
        saved
        createdAt
        updatedAt
        createdBy {
          ...ActorTeaser
        }
      }
      streamId
    }
  }
  ${ActorTeaser}
`;
export type CreateAIConversationMutationFn = Apollo.MutationFunction<
  CreateAIConversation,
  CreateAIConversationVariables
>;

/**
 * __useCreateAIConversation__
 *
 * To run a mutation, you first call `useCreateAIConversation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAIConversation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAiConversation, { data, loading, error }] = useCreateAIConversation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAIConversation(
  baseOptions?: Apollo.MutationHookOptions<CreateAIConversation, CreateAIConversationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateAIConversation, CreateAIConversationVariables>(
    CreateAIConversationDocument,
    options,
  );
}
export type CreateAIConversationHookResult = ReturnType<typeof useCreateAIConversation>;
export type CreateAIConversationMutationResult = Apollo.MutationResult<CreateAIConversation>;
export type CreateAIConversationMutationOptions = Apollo.BaseMutationOptions<
  CreateAIConversation,
  CreateAIConversationVariables
>;
export function mockCreateAIConversation({
  data,
  variables,
  errors,
}: {
  data: CreateAIConversation;
  variables?: CreateAIConversationVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: CreateAIConversationDocument, variables },
    result: { data, errors },
  };
}
